import { getOfferProductsV3 } from '@eneco/dc/services/ProductsPublicService';
import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
} from '@monorepo-types/dc';
import { fromPromise } from 'xstate';

import { OfferErrorMessage, toOfferError } from './getOffer.errors';
import { getOfferRequestBody } from './getOffer.helpers';
import { SmeOffer } from './getOffer.types';
import { FlowContextSme } from '../../context';

export type GetOfferInput = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  values: FlowContextSme;
};

const getOffer = async ({ businessUnit, label, values }: GetOfferInput): Promise<SmeOffer> => {
  try {
    const response = await getOfferProductsV3({ businessUnit, label, requestBody: getOfferRequestBody(values) });

    if (!response.data?.productCombinations?.length) {
      throw new Error(OfferErrorMessage.NotFound);
    }

    return response.data;
  } catch (error) {
    throw toOfferError(error);
  }
};

export type GetOfferOutput = Awaited<ReturnType<typeof getOffer>>;

export const actors = {
  getOffer: fromPromise<GetOfferOutput, GetOfferInput>(async ({ input }) => await getOffer(input)),
};
